import React, { Component } from 'react'

import FilterBodyComponent from './FilterBody.component'

class FilterBodyContainer extends Component {
  constructor(props) {
    super(props)

    const filters = this.props.headers.reduce((prev, curr) => {
      // && curr.filters.length > 0 && Object.keys(curr.filters[0]).length > 0
      if (curr.filters) {
        let obj = {}

        if (Array.isArray(curr.filters)) {
          obj = curr.filters[0]
        } else {
          obj = curr.filters
        }
        obj.filterTitle = curr.title

        const output = [obj] || []

        return prev.concat(output)
      }

      return prev.concat([])
    }, [])

    this.state = {
      filters,
      appliedFilters: props.appliedFilters
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      appliedFilters: newProps.appliedFilters
    })
  }

  render() {
    const {filters, appliedFilters} = this.state
    const {analytics, addAppliedFilter, handleRemoveFilter, api, savedFilters, quickFilters, extraFilters, setAllFilters, i18n, handleRemove, handleInputValidationErrors} = this.props

    return (
      <FilterBodyComponent
        analytics={analytics}
        addAppliedFilter={addAppliedFilter}
        handleRemoveFilter={handleRemoveFilter}
        api={api}
        i18n={i18n}
        extraFilters={extraFilters}
        handleRemove={handleRemove}
        savedFilters={savedFilters}
        quickFilters={quickFilters}
        setAllFilters={setAllFilters}
        filters={filters}
        appliedFilters={appliedFilters}
        handleInputValidationErrors={handleInputValidationErrors}
      />
    )
  }
}

export default FilterBodyContainer
